import apiClient from '@/config/api';
import type { Pin, PinStats, PinListFilter } from '@/types/pin';
import type { SportType } from '@/types/user';
import type { PaginatedResponse } from '@/types/common';

export interface PinListParams extends PinListFilter {
  page?: number;
  pageSize?: number;
  bounds?: { north: number; south: number; east: number; west: number };
  sortBy?: 'userCount' | 'createdAt';
  sortOrder?: 'asc' | 'desc';
}

export interface PinCreateRequest {
  name: string;
  center: { lat: number; lng: number };
  boundary?: GeoJSON.Polygon;
  level: string;
  parentPinId?: string;
  // 핀 접근 제약 (null = 해제). 빈 배열/null = 전체 허용
  allowedSports?: SportType[] | null;
  minAge?: number | null;
  maxAge?: number | null;
}

export interface PinUpdateRequest extends Partial<PinCreateRequest> {
  isActive?: boolean;
}

export const pinsApi = {
  // 핀 목록 조회
  getList: async (params?: PinListParams): Promise<PaginatedResponse<Pin>> => {
    const response = await apiClient.get('/admin/pins', { params });
    return response.data.data;
  },

  // 핀 상세 조회
  getDetail: async (id: string): Promise<Pin> => {
    const response = await apiClient.get(`/admin/pins/${id}`);
    return response.data.data;
  },

  // 핀 통계 조회
  getStats: async (id: string): Promise<PinStats> => {
    const response = await apiClient.get(`/admin/pins/${id}/stats`);
    return response.data.data;
  },

  // 핀 생성
  create: async (data: PinCreateRequest): Promise<Pin> => {
    const response = await apiClient.post('/admin/pins', data);
    return response.data.data;
  },

  // 핀 수정
  update: async (id: string, data: PinUpdateRequest): Promise<Pin> => {
    const response = await apiClient.patch(`/admin/pins/${id}`, data);
    return response.data.data;
  },

  // 핀 활성화
  activate: async (id: string): Promise<Pin> => {
    const response = await apiClient.patch(`/admin/pins/${id}/activate`);
    return response.data.data;
  },

  // 핀 비활성화
  deactivate: async (id: string): Promise<Pin> => {
    const response = await apiClient.patch(`/admin/pins/${id}/deactivate`);
    return response.data.data;
  },
};
